import { KEY, REQUIRED_STRING, Resource } from "shelving";
import { POST_FORM_SCHEMA } from "shared/schema";

export const CREATE_POST = new Resource("createPost", POST_FORM_SCHEMA, REQUIRED_STRING);
export const DELETE_POST = new Resource("deletePost", KEY);
